import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotifyContext from "./context";

class Notifyer extends Component {
  notify = (type, message) => {
    toast[type](message);
  };

  render() {
    return (
      <NotifyContext.Provider value={this.notify}>
        <ToastContainer
          position="top-left"
          autoClose={2000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable={false}
          pauseOnHover
        />
        {this.props.children}
      </NotifyContext.Provider>
    );
  }
}

export default Notifyer;
